import React from 'react';
import './styles.css';
import PaymentMethod from './PaymentMethod';

const PaymentMethods = ({
  data,
  defaultId,
  extended = true,
  editable = false,
  selected,
  onSelect,
  canAdd = false,
  onEdit,
  canDelete = false,
  onDelete,
  onMakeDefault,
}) => {
  if (!data) {
    return null;
  }

  return (
    <div className={'payment-methods-container'}>
      <table className={'payment-methods'}>
        <tbody>
          {data.map((method, index) => (
            <PaymentMethod
              key={method.id}
              data={method}
              isDefault={defaultId === method.id}
              extended={extended}
              editable={editable}
              selected={selected}
              onSelect={onSelect}
              onEdit={onEdit}
              canDelete={canDelete}
              onDelete={onDelete}
              onMakeDefault={onMakeDefault}
              isLast={index >= data.length - 2}
            />
          ))}
          {canAdd && (
            <tr className={'bank-card'} onClick={() => {
              onSelect('new');
            }}>
              <td className={'bank-card__select'}>
                <input
                  type="radio"
                  name="payment-method"
                  value="new"
                  checked={selected === 'new'}
                  onChange={() => {
                    onSelect('new');
                  }}
                />
              </td>
              <td className={'bank-card__icon'} colSpan={2}>
                Add new payment method
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentMethods;
